import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { MTS } from '../../components/mechanization/MTS';  

const MTSPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>МТС</title>
            </Helmet>
            <MTS/>
        
        </>
    );
};

export default MTSPage
